import { Skeleton } from "@/components/ui/skeleton";

export default function RosterViewSkeleton() {
  return (
    <div role="status" aria-label="근무표를 불러오는 중입니다" className="w-full px-5 pt-2 pb-10">
      <span className="sr-only">근무표를 불러오는 중입니다.</span>
      <div aria-hidden="true" className="mx-auto w-full max-w-[1440px] space-y-4">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <Skeleton className="h-10 w-44" />
            <Skeleton className="h-4 w-32" />
          </div>
          <Skeleton className="size-10" />
        </div>
        <Skeleton className="h-28 w-full" />
        <div className="overflow-hidden rounded-lg">
          <div className="flex gap-4 p-3">
            <Skeleton className="h-6 w-40 shrink-0" />
            <Skeleton className="h-6 flex-1" />
          </div>
          {Array.from({ length: 10 }, (_, row) => (
            <div key={row} className="flex gap-4 p-3">
              <div className="flex w-40 shrink-0 items-center gap-3">
                <Skeleton className="size-5 rounded-full" />
                <Skeleton className={row % 2 === 0 ? "h-4 w-20" : "h-4 w-16"} />
              </div>
              <Skeleton className="h-5 flex-1" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
